import { validateCardNumber } from '../card';
export const cardNumberValidatorKey = 'cardNumber';
export const cardNumberValidator = (value) => ({
    [cardNumberValidatorKey]: validateCardNumber(value),
});
//# sourceMappingURL=card-number.validator.js.map